/**
 * Frontend client for model version history + cert/quote metadata
 * (server/modules/vault/version.routes, mounted under /vault).
 */
import { apiGet, apiPost, apiPatch } from "../shared/apiClient";
import type { VaultModel } from "./vaultApi";

export interface ModelVersion {
  _id: string;
  modelId: string;
  version: number;
  config?: Record<string, unknown>;
  note?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface ModelMeta {
  certNumber?: string;
  certLab?: string;
  quote?: Record<string, unknown>;
}

export const listVersions = (modelId: string) =>
  apiGet<ModelVersion[]>(`/vault/models/${modelId}/versions`);

export const restoreVersion = (modelId: string, versionId: string) =>
  apiPost<VaultModel>(`/vault/models/${modelId}/versions/${versionId}/restore`);

export const saveModelMeta = (modelId: string, meta: ModelMeta) =>
  apiPatch<VaultModel>(`/vault/models/${modelId}/meta`, meta);
